import "./new-registration.scss";

import { useGetPublicService } from "@domain/util-service/new-util-service/get-public-service.hook";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FormProvider } from "react-hook-form";
import { FaCheckCircle } from "react-icons/fa";

import FormRegistration from "../form-registration/form-registration";
import { useNewRegistration } from "./new-registration.hook";

export function NewRegistration() {
  const {
    isCreating,
    formMethod,
    handleValidate,
    handleValidateError,
    showSuccessModal,
    setShowSuccessModal,
    logo,
  } = useNewRegistration();

  const { isFetchingServices, contactInfo, serviceOptions } =
    useGetPublicService();

  const consentAgreement = formMethod.watch("consentAgreement");

  return (
    <div id="NewRegistration" className="registration-page">
      <div className="registration-container">
        <section className="info-side">
          <div className="info-content">
            <div className="registration-header">
              {logo && (
                <div className="logo-container">
                  <img src={logo} alt="Client Logo" className="client-logo" />
                </div>
              )}

              <div className="header-content">
                <h1 className="title">Book Your Appointment</h1>
                <p className="subtitle">
                  Fill in the details to complete your booking.
                </p>
              </div>
            </div>

            <div className="contact-info">
              <div className="contact-details">
                <div className="contact-item">
                  <i className="pi pi-envelope"></i>
                  <div>
                    <span className="contact-label">Email</span>
                    <span className="contact-value">{contactInfo.email}</span>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="pi pi-phone"></i>
                  <div>
                    <span className="contact-label">Phone</span>
                    <span className="contact-value">{contactInfo.phone}</span>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="pi pi-facebook"></i>
                  <div>
                    <span className="contact-label">Facebook</span>
                    <span
                      className="contact-value contact-link"
                      onClick={() =>
                        contactInfo.postRegistrationLink &&
                        window.open(contactInfo.postRegistrationLink, "_blank")
                      }
                      style={{
                        cursor: contactInfo.postRegistrationLink
                          ? "pointer"
                          : "default",
                        opacity: contactInfo.postRegistrationLink ? 1 : 0.5,
                      }}
                    >
                      {contactInfo.postRegistrationLink
                        ? "Visit our page"
                        : "Not available"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="decorative-elements">
              <div className="floating-circle circle-1"></div>
              <div className="floating-circle circle-2"></div>
            </div>
          </div>
        </section>

        <section className="form-side">
          <div className="form-content">
            <FormProvider {...formMethod}>
              <form
                className="registration-form"
                onSubmit={formMethod.handleSubmit(
                  handleValidate,
                  handleValidateError
                )}
              >
                <FormRegistration
                  serviceOptions={serviceOptions}
                  isFetchingServices={isFetchingServices}
                  isEdit={false}
                />

                <div className="submit-section">
                  <div className="submit-button-wrapper">
                    <Button
                      label={isCreating ? "Saving..." : "Complete Booking"}
                      icon="pi pi-check"
                      className="submit-button"
                      disabled={isCreating || !consentAgreement}
                      type="submit"
                    />

                    {!consentAgreement && (
                      <div className="consent-tooltip">
                        You must agree to the consent before submitting.
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </section>
      </div>

      <Dialog
        visible={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modal
        closable
        className="success-dialog"
        style={{ width: "32rem" }}
      >
        <div className="flex flex-col items-center space-y-4 pt-4">
          <FaCheckCircle className="text-green-600" size={48} />
          <h2 className="text-2xl font-semibold text-gray-800">
            Thank You for Booking!
          </h2>
          <p className="text-gray-600">
            Your appointment has been successfully booked. We'll contact you
            soon with more details.
          </p>

          {contactInfo.postRegistrationLink && (
            <>
              <p className="text-sm text-gray-500">
                Stay updated with our latest news and offers:
              </p>
              <Button
                label="Follow us on Facebook"
                onClick={() => {
                  window.open(contactInfo.postRegistrationLink, "_blank");
                  setShowSuccessModal(false);
                }}
              />
            </>
          )}
        </div>
      </Dialog>
    </div>
  );
}

export default NewRegistration;
